import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {SubmitResponseModel} from '../entities/SubmitResponseModel';
import {InfoCadastroResponseModel} from "../entities/InfoCadastroResponseModel";


@Injectable({
  providedIn: 'root'
})
export class RestService {
  static readonly OSS_CONTEXT_ROOT_URL = '/oss';

  readonly REST_NETP_CONTROLLER_URL = RestService.OSS_CONTEXT_ROOT_URL + '/import/registo/';
  readonly REST_INT_CONTROLLER_URL = RestService.OSS_CONTEXT_ROOT_URL + '/import-by-int/netp/registo/';

  readonly SUBMIT_NEW_ENDPOINT = 'submeter-novo-registo';
  readonly SUBMIT_EDIT_ENDPOINT = 'submeter-editar-registo';
  readonly GET_INFO_CADASTRO_ENDPOINT = 'obter-info-cadastro';

  static SUBMIT_HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'POST',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }),
  };

  constructor(private http: HttpClient) {
  }

  /* form submission by NETP */

  public submitNewByNetp(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrlByNetp(this.SUBMIT_NEW_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  public submitEditByNetp(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrlByNetp(this.SUBMIT_EDIT_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  /* form submission by INTERMEDIARY */

  public submitNewByInt(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrlByInt(this.SUBMIT_NEW_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  public submitEditByInt(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrlByInt(this.SUBMIT_EDIT_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  public getInfoCadastro(nif: number): Observable<InfoCadastroResponseModel> {
    return this.http.get<InfoCadastroResponseModel>(this.getFullUrlByInt(this.GET_INFO_CADASTRO_ENDPOINT), {
      ...RestService.SUBMIT_HTTP_OPTIONS,
      params: new HttpParams({fromObject: {'nif': `${nif}`}})
    })
  }

  /**
   * Returns the full url of the request for NETP-by-NETP registrations.
   */
  private getFullUrlByNetp(url: string): string {
    return this.REST_NETP_CONTROLLER_URL + url;
  }

  /**
   * Returns the full url of the request for NETP-by-INT registrations.
   */
  private getFullUrlByInt(url: string): string {
    return this.REST_INT_CONTROLLER_URL + url;
  }
}
